import { mainApi } from "services/main";
import {
  SearchPendingReassessmentLinesRequest,
  SearchPendingReassessmentLinesResponse,
  RegisterManualFXRatesRequest,
  RegisterManualFXRatesResponse,
  RegisterManualFXRatesEntryRequest,
  RegisterManualFXRatesEntryResponse,
  ApproveManualFXRatesRequest,
  ApproveManualFXRatesResponse,
  GetFXRatePendingApprovalsResponse,
  GetMySubmissionsResponse,
} from "./interfaces";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    searchPendingReassessmentLines: builder.query<
      SearchPendingReassessmentLinesResponse,
      SearchPendingReassessmentLinesRequest
    >({
      query: (params) => ({
        url: "reassessment/manual/search_pending_reassessment_lines",
        method: "POST",
        body: params,
      }),
    }),
    registerManualFXRates: builder.mutation<
      RegisterManualFXRatesResponse,
      RegisterManualFXRatesRequest
    >({
      query: (params) => ({
        url: "reassessment/manual/register_fx_rates",
        method: "POST",
        body: params,
      }),
    }),
    getMySubmissions: builder.query<GetMySubmissionsResponse, string>({
      query: (requestedByUser) => ({
        url: `reassessment/manual/get_fx_rate_submissions?requestedByUser=${requestedByUser}`,
        method: "POST",
      }),
    }),
    registerManualFXRatesEntry: builder.mutation<
      RegisterManualFXRatesEntryResponse,
      RegisterManualFXRatesEntryRequest
    >({
      query: (params) => ({
        url: "reassessment/manual/register_fx_rates_entry",
        method: "POST",
        body: params,
      }),
    }),
    approveManualFXRates: builder.mutation<
      ApproveManualFXRatesResponse,
      ApproveManualFXRatesRequest
    >({
      query: (params) => ({
        url: "reassessment/manual/approve_fx_rates",
        method: "POST",
        body: params,
      }),
    }),
    getFXRatePendingApprovals: builder.query<
      GetFXRatePendingApprovalsResponse,
      { nextToken?: string } | void
    >({
      query: (params) => ({
        url: "reassessment/manual/get_fx_rate_pending_approvals",
        method: "POST",
        body: params || {},
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useSearchPendingReassessmentLinesQuery,
  useRegisterManualFXRatesMutation,
  useRegisterManualFXRatesEntryMutation,
  useApproveManualFXRatesMutation,
  useGetFXRatePendingApprovalsQuery,
  useGetMySubmissionsQuery,
} = extendedApi;
